module.exports = __webpack_public_path__ + "img/svg/step6.82e5d3e963b3f9426d58ae5280835b6b.svg";